export const apiUrl = '/api/v1';
